export var uppercase = function uppercase(str) {
  return str.toUpperCase();
};
/**
 * Convert Headers instance into regular object
 */
export var HeadersInstanceToPlainObject = function HeadersInstanceToPlainObject(headers) {
  var o = {};
  headers.forEach(function (v, k) {
    o[k] = v;
  });
  return o;
};